import { NoteCheckIcon } from './NoteCheckIcon';

/**
 * author: Colton Wiscombe
 * id A4B7F3B4-25B2-4786-A02F-FDA4F963E580
 * name note-check
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-check.svg
 * tags
 */
export const StickyNoteCheckIcon = NoteCheckIcon;
export default StickyNoteCheckIcon